import supervisor from './supervisor';

export default {
	supervisorPage: supervisor
}